import { AxiosError } from 'axios';

export const isAxiosError = (error: unknown): error is AxiosError => {
  if (error === undefined || error === null) {
    return false;
  }

  const partialError = error as Partial<AxiosError>;

  return partialError.status !== undefined;
};
